import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

function HouseholdApproval() {
  const [pending, setPending] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  // Geo dropdown states
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [panchayats, setPanchayats] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedPanchayat, setSelectedPanchayat] = useState("");
  const [village, setVillage] = useState("");

  // Load pending households
  const loadPending = async () => {
    const res = await axios.get(`${API_BASE}/households/raw`, {
      headers: authHeaders(),
    });
    setPending(Array.isArray(res.data) ? res.data : []);
  };

  useEffect(() => {
    loadPending();
  }, []);

  // Load initial states
  useEffect(() => {
    axios.get(`${API_BASE}/geo/states`)
      .then(res => setStates(Array.isArray(res.data) ? res.data : []));
  }, []);

  // Load districts when state changes
  useEffect(() => {
    if (selectedState)
      axios.get(`${API_BASE}/geo/districts/${selectedState}`)
        .then(res => setDistricts(Array.isArray(res.data) ? res.data : []));
  }, [selectedState]);

  // Load blocks when district changes
  useEffect(() => {
    if (selectedDistrict)
      axios.get(`${API_BASE}/geo/blocks/${selectedDistrict}`)
        .then(res => setBlocks(Array.isArray(res.data) ? res.data : []));
  }, [selectedDistrict]);

  // Load panchayats when block changes
  useEffect(() => {
    if (selectedBlock)
      axios.get(`${API_BASE}/geo/panchayats/${selectedBlock}`)
        .then(res => setPanchayats(Array.isArray(res.data) ? res.data : []));
  }, [selectedBlock]);

  // Open modal
  const openApprovalModal = (household) => {
    setSelected(household);
    setModalOpen(true);
  };

  // Submit approval
  const approveHousehold = async () => {
    try {
      await axios.post(
        `${API_BASE}/households/approve`,
        {
          raw_id: selected.id,
          state: selectedState,
          district: selectedDistrict,
          block: selectedBlock,
          panchayat: selectedPanchayat,
          village,
        },
        {
          headers: authHeaders(),
        }
      );

      alert("Household Approved!");

      setModalOpen(false);
      setSelectedState("");
      setSelectedDistrict("");
      setSelectedBlock("");
      setSelectedPanchayat("");
      setVillage("");

      loadPending();
    } catch (err) {
      console.error(err);
      alert("Approval failed");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Pending Household Approvals</h2>

      {pending.length === 0 ? (
        <p>No pending households</p>
      ) : (
        <table border="1" cellPadding="10" style={{ width: "100%", marginTop: 20 }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Village</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {pending.map((h) => (
              <tr key={h.id}>
                <td>{h.id}</td>
                <td>{h.name}</td>
                <td>{h.phone}</td>
                <td>{h.village_raw || "-"}</td>
                <td>
                  <button onClick={() => openApprovalModal(h)}>Approve</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Approval Modal */}
      {modalOpen && (
        <div style={{
          position: "fixed",
          top: "20%",
          left: "30%",
          width: "40%",
          padding: "20px",
          background: "white",
          border: "1px solid black"
        }}>
          <h3>Approve Household ID: {selected?.id}</h3>

          <label>State</label>
          <select value={selectedState} onChange={(e) => setSelectedState(e.target.value)}>
            <option value="">Select State</option>
            {states.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
          <br /><br />

          <label>District</label>
          <select value={selectedDistrict} onChange={(e) => setSelectedDistrict(e.target.value)}>
            <option value="">Select District</option>
            {districts.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          <br /><br />

          <label>Block</label>
          <select value={selectedBlock} onChange={(e) => setSelectedBlock(e.target.value)}>
            <option value="">Select Block</option>
            {blocks.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
          <br /><br />

          <label>Panchayat</label>
          <select value={selectedPanchayat} onChange={(e) => setSelectedPanchayat(e.target.value)}>
            <option value="">Select Panchayat</option>
            {panchayats.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
          <br /><br />

          <label>Village</label>
          <input
            type="text"
            value={village}
            onChange={(e) => setVillage(e.target.value)}
          />
          <br /><br />

          <button onClick={approveHousehold}>Submit</button>
          <button onClick={() => setModalOpen(false)} style={{ marginLeft: 10 }}>
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}

export default HouseholdApproval;
